<template>
    <div>
        <p>
            <label>
                <input type="radio" value="others" v-model="picked">
                <span class="s-half-lpad">{{ allOthersLabel }}</span>
                <small class="-dimmed" v-if="allOthersHelper">{{ allOthersHelper }}</small>
            </label>
        </p>
        <p>
            <label>
                <input type="radio" value="buildings" v-model="picked">
                <span class="s-half-lpad">{{ buildingsLabel }}</span>
                <small class="-dimmed" v-if="buildingsHelper">{{ buildingsHelper }}</small>
            </label>
        </p>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'question-target-selector',

    props:
    {
        allOthersLabel: String,
        allOthersHelper: String,
        buildingsLabel: String,
        buildingsHelper: String,
    },

    data: () => ({
        picked: 'others',
    }),

    watch:
    {
        picked: function (newPick)
        {
            this.dispatchSetExportBuildings([newPick === 'buildings'])
        },
    },

    computed:
    {
        ...mapState({
            exportBuildings: state => state.exportBuildings,
        }),
    },

    methods: mapActions({
        dispatchSetExportBuildings: 'SET_EXPORT_BUILDINGS',
    }),
}
</script>

<style scoped>
.red {
    color: red;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-target-selector.vue